import { DragIndicator, MoreHoriz } from '@mui/icons-material';
import { Grid, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { DisplayText } from 'components';
import { useMenu } from 'hooks';

export const EventVideoItem = ({ item, index, handleDeleteClick }) => {
	const classes = useStyles();
	const { open, anchorEl, handleToggleMenu, handleClose } = useMenu();

	const renderMenu = () => (
		<Menu open={open} onClose={handleClose} anchorEl={anchorEl}>
			<MenuItem onClick={(e) => handleDeleteClick(item)}>Delete</MenuItem>
		</Menu>
	);
	return (
		<Grid
			container
			spacing={1}
			className={classes.root}
			sx={{ marginBottom: 3 }}
		>
			<Grid item md={2} xs={12} className={classes.item}>
				<DragIndicator />
			</Grid>
			<Grid item md={3} xs={12} className={classes.item}>
				<Typography
					variant="body1"
					color={'primary'}
					className={classes.text}
					sx={{ textAlign: 'center' }}
				>
					{item.title}
				</Typography>
			</Grid>
			<Grid
				item
				md={6}
				xs={12}
				className={classes.item}
				sx={{ display: 'grid', placeItems: 'center' }}
			>
				{/* <DisplayText  text={item.url} /> */}
				<video
					height="90"
					width="100"
					style={{ flex: 1, width: '100', objectFit: 'contain' }}
					src={item.video_url}
				/>
			</Grid>
			<Grid className={classes.item} item md={1} xs={12}>
				<IconButton onClick={(e) => handleToggleMenu(e)}>
					<MoreHoriz />
					{renderMenu()}
				</IconButton>
			</Grid>
		</Grid>
	);
};

export default EventVideoItem;

const useStyles = makeStyles((theme) => ({
	root: {
		minHeight: 80,
		paddingLeft: 20,
		paddingRight: 20
	},
	item: { verticalAlign: 'center' },
	text: { paddingTop: 20 },
	icon: { color: '#757575', marginLeft: 20, marginTop: 20 },
	button: { paddingTop: 20, paddingBottom: 20 }
}));
